module.exports = __webpack_public_path__ + "assets/icons/manager-logo.eece8916e464d9efe0b26c01f6662ec5.svg";